// eslint-disable-next-line import/no-unresolved
module.exports = require('./dist/index.js').default;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-with-styles-interface-css/index.js
// module id = 4298
// module chunks = 168707334958949